import { createConfig } from 'components/configProvider/ConfigProvider';

import { IVideoElementRendererGlobalConfig } from './IVideoElementController';

export const defaultVideoElementControllerConfig: IVideoElementRendererGlobalConfig = {
  videoElementControllerConfig: {
    limitCheckingAutoplay: 5,
    minimalPossibleVideoDimension: 50,
    timeoutUpdateStatusPlaying: 2000,
    timeoutUpdateVideoDuration: 500,
  },
};

export const { ConfigConsumer, setConfig, resetConfig } = createConfig(
  defaultVideoElementControllerConfig,
);
